import classNames from 'classnames';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import router from 'router';
import { ReactComponent as LogoutIcon } from 'assets/svg/logout.svg';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'store/reducers/auth';
import { checkHasAnyRoleOrPermission } from 'constants/permission';
import { Tooltip } from 'antd';

const SideBar = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { permissions, roles } = useSelector((state) => state.auth);

  const onClickLogout = () => {
    dispatch(logout());
  };

  return (
    <div className="sidebar">
      <div className="sidebar__logo">
        <span className="text-name">DSP</span>
      </div>
      <div className="sidebar__menu">
        {router
          .filter((item) => item.leftMenu)
          .filter((item) =>
            checkHasAnyRoleOrPermission(
              permissions,
              roles,
              item.role,
              item.permission
            )
          )
          .map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={{ textDecoration: 'none' }}
            >
              <Tooltip title={item.title} placement="right">
                <div
                  className={classNames('router-item', {
                    'router-item--active': pathname.includes(item.path),
                  })}
                >
                  <div className="router-item__icon">{item.icon}</div>
                  <div
                    className={classNames({
                      'router-item__under-active': pathname.includes(item.path),
                    })}
                  ></div>
                </div>
              </Tooltip>
            </Link>
          ))}
      </div>
      <div className="sidebar__logout" onClick={onClickLogout}>
        <LogoutIcon />
      </div>
    </div>
  );
};

export default SideBar;
